import { TRANSITION_MOUNT_TYPE } from 'enums'

export function getTransitionStartTime(transition, leftAsset, rightAsset) {
  let startTime = 0

  if (transition.mountType === TRANSITION_MOUNT_TYPE.BETWEEN) {
    startTime = rightAsset.startTime
  }

  if (transition.mountType === TRANSITION_MOUNT_TYPE.OUT) {
    startTime = leftAsset?.endTime - transition.duration
  }

  if (transition.mountType === TRANSITION_MOUNT_TYPE.IN) {
    startTime = rightAsset?.startTime
  }

  return startTime
}
